export default __webpack_public_path__ + "static/media/woman.15c4a5f1.png";